import React, { useMemo } from "react";
import NexthinkSmartActions from "../../../components/ai-assist-refactored/action-components/nexthink/smart.actions.component";
import { WidgetComponent } from "../widget.types";
import { NexthinkActionWidgetMeta } from "@me8eon/ai.tools.nextthink/src/model/nexthinkWidget";

export const SmartSolutionWidget: WidgetComponent = (props) => {
    const values = props.values._meta.widget as NexthinkActionWidgetMeta;
    const { devices, document, queryLanguage } = values.props;
    const data = useMemo(
        () => ({
            rag: "",
            deviceDetails: { data: devices },
            queryLanguage,
        }),
        [devices, queryLanguage]
    );

    return (
        <div
            className="ai-assist-wrapper"
            style={{
                flexDirection: "column",
                minHeight: "auto",
                padding: 0,
                margin: 0,
                gap: 0,
            }}
        >
            <NexthinkSmartActions
                enableNexthinkAction={true}
                role="assistant"
                data={data}
            />
        </div>
    );
};
